import { useState } from 'react'

import { RequestStatus } from 'core/domain/Request'

import { sentry } from 'legacy/utils/sentry'

import { type Driver } from '../../domain/Driver'
import { assignDriver } from '../../use-cases/assignDriver'

export function useAssignDriver() {
  const [assignDriverStatus, setAssignDriverStatus] = useState(RequestStatus.Initial)

  async function assignDriverFn(shipmentId: string, driver: Driver) {
    try {
      setAssignDriverStatus(RequestStatus.Pending)
      await assignDriver(shipmentId, driver)
      setAssignDriverStatus(RequestStatus.Done)
    } catch (error) {
      setAssignDriverStatus(RequestStatus.Error)
      sentry.log(error)
      throw new Error('Could not assign the driver', { cause: error as Error })
    }
  }

  return { assignDriver: assignDriverFn, assignDriverStatus }
}
